<template>
</template>

<script>
export default {
    name : 'TicketDetailReplyForm',

    mounted() {
        window.showTicketDetailReplyForm();
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketDetailReplyForm.vue